import { typeUtils } from '@festina-life/core'

export type EnumDraftCreationData = {
  name: string
}

export const validateKey =
  typeUtils.createValidator<NonNullable<EnumDraftCreationData>>()
